<div class="event-form-wrap event-form" (keydown.enter)="$event.preventDefault()">

    <ig-field label="Name" [(ngModel)]="command.name" [isRequired]="true" [disabled]="!toggles.placeCalendar"
        [formControl]="createPlaceForm.get('name')">
    </ig-field>
    <ig-address-input label="Location (type and select from the dropdown)"
        matTooltip="please type and select an address from the dropdown" [isRequired]="true"
        [disabled]="!toggles.placeCalendar" [(ngModel)]="command.address"
        [formControl]="createPlaceForm.get('address')">
    </ig-address-input> 
    <div (click)="showEditCategoryModal()" class="edit-category-btn" [class.disabled]="!toggles.placeCalendar">Edit
        Category</div>
    <ig-field label="Category" [(ngModel)]="categoryText" [isRequired]="true" [disabled]="true"
        [matTooltip]="categoryText" [formControl]="createPlaceForm.get('category')">
    </ig-field>

    <ig-field label="Web Site" [(ngModel)]="command.website" [disabled]="!toggles.placeCalendar"
        [formControl]="createPlaceForm.get('website')">
    </ig-field>
    <ig-row>
        <ig-col [md]="6">
            <mat-form-field class="text-area">
                <textarea #description matInput placeholder="Description" type="textArea"
                    [(ngModel)]="command.description" [disabled]="!toggles.placeCalendar" (input)="descriptionChange()"
                    [formControl]="createPlaceForm.get('description')">
                        </textarea>
            </mat-form-field>
        </ig-col>
        <ig-col [md]="6">
            <ig-image-selector [command]="command" label="Upload Place Image" [label2]="imageUploaderLabel2"
                [disabled]="!toggles.placeCalendar" (onImageChanged)="onImageChange($event)"
                [selectedImageData]="selectedImageData">
            </ig-image-selector>
            <mat-checkbox *ngIf="isImageChanged" [(ngModel)]="hasCopyrights">Please note that any images uploaded or
                used in this software must either be royalty-free or owned by the client. By uploading or using an
                image, you acknowledge that you have the necessary rights to use it and that you will be solely
                responsible for any copyright infringement or other legal issues that may arise from the use of the
                image. We strongly advise our users to exercise due diligence and ensure that they have the necessary
                rights to use any images uploaded or used in this software.
            </mat-checkbox>
        </ig-col>
    </ig-row>

    <ig-button [isAsync]="true"
        [disabled]="createPlaceForm.invalid||!toggles.placeCalendar || (isImageChanged && !hasCopyrights)"
        color="accent" size="md" (trigger)="createPlace($event)">
        Create place
    </ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/manually.add/create.place/create.place.component.html